<template>
  <b-container class="m-0 p-0">
    <b-table
      :items="items"
      :fields="['Omschrijving','ToegewezenAan',{key:'DatumKolom',label: 'Ingepland op' },'Actie']"
      :filter="filter"
      dark
      bordered
      selectable
      @row-clicked="(item) => {audit = item; showAuditModal = true;}"
    >
      <template #table-busy>
        <div class="text-center text-white my-2">
          <b-spinner class="align-middle mx-2" />
          <strong>Laden...</strong>
        </div>
      </template>
      <template #cell(ToegewezenAan)="row">
        {{ row.item.data.toegewezen_aan ? row.item.data.toegewezen_aan.Naam : '-' }}
      </template>

      <template #cell(Actie)="row">
        <b-button 
          v-if="row.item.data.datum == null"
          block
          @click="plantaak(row.item)"
        >
          <font-awesome-icon icon="calendar" /> uitvoering op
        </b-button>
        <b-button 
          v-else-if="row.item.data.status == 'OPEN'" 
          variant="success" 
          block
          @click="uitvoeringTaak(row.item)"
        >
          <font-awesome-icon icon="check" /> status bewerken
        </b-button>
        <span v-else>
          <b-button 
            v-if="row.item.audit_link != null" 
            @click="$router.push(row.item.audit_link)"
          >{{ row.item.audit_link.name }}</b-button>
          <secure-bijlagen 
            v-if="row.item.data.type == 'Standaard'" 
            :bijlagen="row.item.data.bijlagen"
          />
        </span>
      </template>

      <template #cell(Omschrijving)="row">
        {{ row.item.titel }}<br>
        <small> {{ row.item.data.omschrijving }}</small>
      </template>

      <template 
        #cell(DatumKolom)="row" 
      >
        <span v-if="row.item.data.datum == null">
          {{ moment(row.item.data.deadline).fromNow() }}
        </span>
        <span v-else>
          {{ moment(row.item.data.datum).format('L') }}
        </span>
      </template>
    </b-table>
    <b-modal 
      v-if="audit != null"
      v-model="showAuditModal" 
      :title="`Bevestiging ${audit.titel}`"
      ok-only
      ok-title="Sluiten" 
      @hide="audit=null"
    >
      <b-form-group label="Toegewezen aan">
        <b-input 
          :value="audit.data.toegewezen_aan.Naam" 
          readonly
        />
      </b-form-group>
      <b-card>
        Kan deze taak afgesloten worden?
        <b-button 
          class="float-right"
          size="lg" 
          variant="success" 
          @click="() => sluit(audit)"
        >
          <font-awesome-icon icon="check" /> Ja voltooid
        </b-button>
      </b-card>
    </b-modal>
  </b-container>
</template>

<script>
import { serviceMixin } from "@/mixins/serviceMixin.js";
import { verkoopMixin } from "@/mixins/verkoopMixin.js";
import SecureBijlagen from '../../components/SecureBijlagen.vue';
export default {
  name: "AccorderingTaken",
  components: { SecureBijlagen },
  mixins: [serviceMixin, verkoopMixin],
  props: {
    filter: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      items: [],
      audit: null,
      showAuditModal: false
    };
  },
  mounted() {
    this.getAudit();
  },
  methods: {
    getAudit() {
      var vm = this;
      this.busy = true;
      this.get("/user/profile/audit")
        .then((resp) => {
          this.items = resp.data.events;
        })
        .finally(() => {
          vm.busy = false;
        });
    },
    sluit(taak) {
      console.log(taak.data.url)
      console.log(taak)
      this.updateTrajectTaak(taak.data.url + "controle",{payload: taak}).then(resp => this.removeFromList(resp.data.taak))
    },
    removeFromList(taak) {
      var index = this.items.map(d => d.data.id).indexOf(taak.data.id)
      console.log(index) 
      this.items.splice(index,1);
      this.audit = null
      this.showAuditModal = false
    },
  },
};
</script>
